// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import VueMaterial from 'vue-material';
import 'vue-material/dist/vue-material.css';
import * as VueGoogleMaps from 'vue2-google-maps';

import App from './App';
import router from './router';

import jump from '../node_modules/jump.js';
import lodash from '../node_modules/lodash';

import { apiSetting } from './utility/api_client';
import CONST from './config/constant-home';

Vue.prototype.jump = jump;
Vue.prototype._ = lodash;
apiSetting({
  CONST,
});

Vue.config.productionTip = false;

Vue.use(VueMaterial);

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyB6uiTwF7zy14ArRx7PG4lXUG3bKLvXl_Y',
    libraries: 'places',
  },
});

Vue.material.registerTheme('default', {
  primary: 'blue',
  accent: 'pink',
  warn: 'deep-orange',
  background: 'white',
});

/* eslint-disable no-new */
new Vue({
  router,
  render: h => h(App),
}).$mount('#app');



// WEBPACK FOOTER //
// ./src/main.js